import styled from 'styled-components';

export const ManaCircle = styled.div`
  background: radial-gradient(circle at 60% 40%, #33ff00, #152810 70%);
  background-color: green;
  border-radius: 50%;
  width: 25px;
  height: 25px;
  text-align: center;
  padding: 3px;
`;
